import {TagFamily} from './tagFamily';

export class Tag {
    id: number;
    name: string;
    tagFamily: TagFamily;
}



// WEBPACK FOOTER //
// ./src/app/_models/tag.ts